// ====== DISCUSSION TAB FEATURE START ======
export async function postPlanDiscussion({ planId, message, parentId = null, attachments = [] }) {
    try {
      const body = {
        planId,
        message,
        parentId,
        attachments,
      };
      const token = "Bearer " + localStorage.getItem("authToken");
      const requestOptions = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: token,
        },
        body: JSON.stringify(body),
      };
      
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}v1/plans/${planId}/discussions`,
        requestOptions
      );
      
      const data = await response.json();
      return data;
    } catch (error) {
      return { success: false, error: error.message };
    }
  }
  // ====== DISCUSSION TAB FEATURE END ====== 